module.exports = __webpack_public_path__ + "img/dead-grey-trunk-06.b15cf127.png";